module.exports = __webpack_public_path__ + "static/media/planification_board.eb1f249d.png";